<template>
  <div class="row">
    <div class="col-md-10">
      <b-breadcrumb class="font-weight-bold" style="color: white; background-color: #05428E; font-size: 14px;">
        Relatório Informativo Pagamento Anual:
      </b-breadcrumb>
    </div>

    <div class="col-md-10">
      <form class="form_padrao pt-2">
        <div class="form-row">

          <b-form class="form-group flutuante col-md-6">

            <div class="label">* Operadora</div>
            <p class="mb-4"></p>
            <b-form-select name="operadora" id="operadora" v-model="operador.operadora" placeholder="Selecione">
              <option value="01">UNIMED BH</option>
              <option value="02">SANTA CASA SAÚDE</option>
              <option value="05">BELO DENTE ODONTOPLANO</option>
              <option value="06">VITALLIS</option>
              <option value="08">PREMIUM SAÚDE</option>

            </b-form-select>
          </b-form>


          <b-form class="form-group flutuante col-md-6">
            <div class="label">* Período</div>
            <p class="mb-4"></p>
            <b-form-select name="periodo" id="periodo" v-model="operador.periodo" placeholder="Selecione">
              <option value="2024">Ano 2024</option>
              <option value="2023">Ano 2023</option>
              <option value="2022">Ano 2022</option>
              <option value="2021">Ano 2021</option>
              <option value="2020">Ano 2020</option>
              <option value="2019">Ano 2019</option>
              <option value="2018">Ano 2018</option>
            </b-form-select>
          </b-form>
        </div>



      </form>
    </div>

    <p class="mb-4"></p>
    <p class="mb-4"></p>

    <div class="col-md-10">



      <div class="col-12">
        <p class="mb-4"></p>
        <p class="mb-4"></p>

      </div>

      <hr class="simple" />

      <form class="form_padrao pt-2">
        <!-- Outros campos do formulário aqui -->

        <div class="form-row justify-content-end align-items-end">
          <!-- Outros campos do formulário aqui -->

          <div class="form-group flutuante col-md-3">
            <button type="button" class="btn btn-verde p-0 fit-content" @click="abrirChamado" v-if="!loading">
              <span>Gerar Relatório</span>
            </button>

            <div class="row justify-content-center" v-if="loading">
              <loading />
            </div>
          </div>
        </div>
      </form>

    </div>

  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
  name: "relatorio-Informativo-PagAtual",
  data() {
    return {
      loading: false,
      operador: {
        operadora: "01",
        periodo: "2024",
      },
      breadcrumb: [
        {
          nome: "Relatório Informativo Pagamento Anual",
          id: "SPCRelatorioInformativoPagamentoAnual",
        },
      ],
      produto: {
        nome: "Relatório de Informativo de Pagamento Anual",
        id: "relatorio plano",
      },
    };
  },

  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },

  methods: {
    async abrirChamado() {

      const dadosRelInformativoPagAnual = {
        OPERADORA: this.operador.operadora,
        PERIODO: this.operador.periodo,
        CODSOCIO: `${this.$user.dadosCadastraisAssociado[0].codsociO_TEMP}`
      };

      this.$http
        .post("/api/CdlBh/RelatorioInformativoPagAtual", dadosRelInformativoPagAnual)
        .then((response) => {
          this.loading = false;
          const binaryData = atob(response.data.fileContents);
          // Crie um ArrayBuffer a partir dos dados binários
          const arrayBuffer = new ArrayBuffer(binaryData.length);
          const uint8Array = new Uint8Array(arrayBuffer);
          // Preencha o ArrayBuffer com os dados binários
          for (let i = 0; i < binaryData.length; i++) {
            uint8Array[i] = binaryData.charCodeAt(i);
          }

          // Crie um Blob a partir do ArrayBuffer com o tipo de conteúdo correto
          const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

          // Crie um URL temporário para o Blob
          const url = URL.createObjectURL(blob);

          // Crie um link de download
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = response.data.fileDownloadName; // Nome do arquivo de download

          // Adicione o link de download à página
          document.body.appendChild(downloadLink);

          downloadLink.click();

        })
        .catch(() => {
          this.loading = false;
          this.$toast.open({
            message: "Dados não encontrados!",
            type: "warning",
          });
        });


    },
  }

};
</script>

<style lang="scss" scoped>
.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;

  &:hover {
    background: #05428e;
    color: white;

    .text-muted {
      color: white !important;
    }
  }

  small {
    line-height: 1.5rem;
  }

  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;

    i {
      font-size: 13px;
      color: white;
    }
  }

  &:hover {
    transform: scale(1.05);
  }
}

.form_padrao select {
  background-color: white;
}
</style>import { error } from "jquery";
import { error } from "jquery";